import { IPhoneticSystem } from '../types/IPhoneticSystem';
import {
    PhoneticType, yaleFinals, yaleInitials,
} from '../constants';
import { ISyllable } from '../types/ISyllable';
import convertRomanization from '../helpers/convertRomanization';

const innerRegex = `(${yaleInitials.join('|')})(${yaleFinals.join('|')})`;
const yaleRegex = new RegExp(`^${innerRegex}$`, 'i');

class YaleSystem implements IPhoneticSystem {
    name = PhoneticType.Yale;

    decomposeSyllable(syllables: string): ISyllable {
        const allSylls = syllables.split(';');
        const syllable = allSylls[0];
        const normalizedSyllable = syllable.normalize('NFD');
        const matchYale = yaleRegex.exec(normalizedSyllable.replace(/[\u0300-\u036f]/g, ''));

        if (matchYale) {
            let tone;

            if (matchYale[2].toLowerCase().includes('h')) {
                /* T4-T6 */
                if (normalizedSyllable.includes('\u0300')) {
                    tone = 4;
                } else {
                    tone = normalizedSyllable.includes('\u0301') ? 5 : 6;
                }
            } else {
                /* T1-T3 */
                if (normalizedSyllable.includes('\u0300') || normalizedSyllable.includes('\u0304')) {
                    tone = 1;
                } else {
                    tone = normalizedSyllable.includes('\u0301') ? 2 : 3;
                }
            }

            return {
                valid: true,
                type: PhoneticType.Yale,
                onset: matchYale[1],
                rhyme: syllable.substr(matchYale[1].length, syllable.length - matchYale[1].length),
                tone,
                syllable,
                notone: matchYale[1] + matchYale[2],
                ambiguous: false,
            };
        }

        return {
            valid: false,
            onset: '',
            rhyme: syllable,
            tone: 0,
            syllable,
            notone: syllable,
            type: PhoneticType.Invalid,
            ambiguous: allSylls.length > 1,
        };
    }

    markSyllableBoundaries(message: string): string {
        const yale = innerRegex;

        const lines = message.normalize('NFC').split('\n');

        return lines.map((line) => {
            const mArray = line.replace(/(?=[.!?,;~:])/g, ' ').split(' ');
            for (let i = 0; i < mArray.length; i++) {
                if (!mArray[i].match(`^${yale}$`)) {
                    mArray[i] = mArray[i].replace(new RegExp(`(${yale})(?=${yale})`, 'gi'), '$1#-');
                }
                const dashArray = mArray[i].split('-');
                for (let i = 0; i < dashArray.length; ++i) {
                    if (i + 1 < dashArray.length && dashArray[i][dashArray[i].length - 1] === '#') {
                        dashArray[i] = dashArray[i].substr(0, dashArray[i].length - 1);
                        if ((dashArray[i] + dashArray[i + 1]).match(new RegExp(`^${yale}#?$`, 'gi'))) {
                            dashArray[i + 1] = dashArray[i] + dashArray[i + 1];
                            dashArray[i] = '';
                        }
                    }
                }
                mArray[i] = dashArray.filter((val) => val).join('-');
            }
            return mArray.join(' ').replace(/ (?=[.!?,;~:])/g, '');
        }).join('\n');
    }

    convertTo(message: string, fromSystem: PhoneticType): string {
        return convertRomanization(message, this.name, fromSystem);
    }
}

export default YaleSystem;
